module.exports = __webpack_public_path__ + "img/proje-2.c317f130.jpg";